import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
  selector: "confirm-dialog",
  template: `
    <h1 mat-dialog-title>{{ data.title }}</h1>
    <div mat-dialog-content>
      <h3>{{ data.msg }}</h3>
    </div>
    <div class="separat-height-10"></div>
    <mat-divider></mat-divider>
    <div class="separat-height-5"></div>
    <div class="row">
      <div class="col-sm-12 text-right">
        <button style="outline:none" mat-button [mat-dialog-close]="false">
          {{ libCancelBtn }}&nbsp;<mat-icon
            aria-hidden="false"
            class="setPointer"
            >cancel</mat-icon
          ></button
        >&nbsp;

        <button
          style="outline:none"
          mat-flat-button
          color="primary"
          [mat-dialog-close]="true"
        >
          {{ libConfirmBtn }} &nbsp;
          <mat-icon aria-hidden="false" class="setPointer">done</mat-icon>
        </button>
      </div>
    </div>
  `,
})
export class ConfirmDialogComponent {
  public libCancelBtn;
  public libConfirmBtn;
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (this.data) {
      this.libCancelBtn = this.data.libCancelBtn
        ? this.data.libCancelBtn
        : "Annuler";
      this.libConfirmBtn = this.data.libConfirmBtn
        ? this.data.libConfirmBtn
        : "Confirmer";
    }
  }
}
